import { useContext, useState } from "react";
import { Platform, FlatList, StyleSheet, Button, View } from "react-native";
import CdnImage from "../../common/CdnImage";
import LayoutContext from "../../../contexts/Layout";
import { H6, H1, Paragraph2 } from "../../text";
import { FontAwesome5 } from "@expo/vector-icons";

const HorizontalGrid = (props) => {
    const nodeTypeAlias = props.nodeTypeAlias || "reactHorizontalGrid"
    const MAX_GRIDITEMS = 4;
    const SHRINK_MOBILE_ICONS_BY = 0.7;
    const DESKTOP_FLEX_CONTAINER_WIDTH = 0.8;

    const { layout } = useContext(LayoutContext);
    const [width, setWidth] = useState(0);

    const gridItems = [...Array(4).keys()].filter((_, i) => {
        return props[`item${i + 1}Image`] && props[`item${i + 1}Text`]
    }).map((_, i) => {
        return {
            id: `${props.id}-${i}`,
            image: props[`item${i + 1}Image`],
            text: props[`item${i + 1}Text`]
        }
    });

    const handleLayout = (event) => {
        const width = layout.device.isMobile ? event.nativeEvent.layout.width
            : event.nativeEvent.layout.width - layout?.styleGuide?.spacer1 * 3;
        setWidth(width);
    };

    const Item = (props) => {
        const itemWidth = layout.device.isMobile ? width / 2 : Math.ceil(width / MAX_GRIDITEMS);
        const extension = props.item.image.url.split('.').pop();

        return (
            <View style={[styles.item, { width: itemWidth, margin: layout.styleGuide.spacer1 }, props.item.id % 2 == 0 && { backgroundColor: 'none' }, width <= 0 && { display: 'none' }]}
                dataSet={`margin: ${layout.styleGuide.spacer1}`}
            >
                {extension.equals('svg') && !Platform.OS.equals('web') && (
                    <SvgUri height={105} width={'87%'} uri={props.item.image.url} />
                )}
                {extension?.equals('svg') && Platform.OS.equals('web') && (
                    <img src={props.item.image.url} style={{ width: itemWidth - layout.styleGuide.spacer1 }} />
                )}
                {!extension?.equals('svg') && (
                    <CdnImage uri={props.item.image.url} width={itemWidth * (layout.device.isMobile ? SHRINK_MOBILE_ICONS_BY : 1) - layout.styleGuide.spacer1} />
                )}
                <Paragraph2 extraStyle={{ marginTop: layout.styleGuide.spacer1, fontWeight: 'bold', textAlign: 'center', whiteSpace: 'wrap', flex: 1, alignContent: 'center', marginBottom: layout.device.isMobile && layout.styleGuide.spacer1 }}
                    dataSet={`marginTop: ${layout.styleGuide.spacer1} ${layout.device.isMobile && 'marginBottom:' + layout.styleGuide.spacer1}}`} text={props.item.text} />
                {props.item.link &&
                    <View style={styles.buttonWrapper}>
                        <Button
                            containerStyle={{ flexDirection: 'row', justifyContent: 'flex-start' }}
                            icon={<FontAwesome5 color='#153d6e' name='chevron-circle-right' size={10} style={{ marginLeft: 5 }} />}
                            iconRight={true}
                            onPress={() => window.open(props.item.link, '_blank')}
                            title={<H6 style={{ color: '#153d6e', backgroundColor: 'none' }} text='Follow Link' />}
                            type='clear'
                        />
                    </View>
                }
            </View>
        )
    }

    return (
        <View
            style={{ padding: layout.styleGuide.spacer1 }}
            dataSet={{
                umbracoComponentName: nodeTypeAlias,
                spacerBottom: `StyleGuide.Spacer(${layout.styleGuide.spacer1})`,
                spacerLeft: `StyleGuide.Spacer(${layout.styleGuide.spacer1})`,
                spacerRight: `StyleGuide.Spacer(${layout.styleGuide.spacer1})`,
                spacerTop: `StyleGuide.Spacer(${layout.styleGuide.spacer1})`
            }}>
            <H1 text={props.title} />
            <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
                <FlatList
                    horizontal={!layout.device.isMobile}
                    contentContainerStyle={[styles.flatlist, { padding: layout.styleGuide.spacer1 }, layout.device.isMobile && styles.flatlistMobile]}
                    columnWrapperStyle={styles.wrapper}
                    data={gridItems}
                    renderItem={(item) => <Item {...item} />}
                    keyExtractor={(item) => item.id}
                    ItemSeparatorComponent={<View style={{ marginLeft: layout.styleGuide.spacer1 }} dataSet={{ marginLeft: `StyleGuide.Spacer(${layout.styleGuide.spacer1})` }} />}
                    onLayout={handleLayout}
                    style={!layout.device.isMobile && { flex: DESKTOP_FLEX_CONTAINER_WIDTH }}
                    dataSet={{
                        spacerBottom: `StyleGuide.Spacer(${layout.styleGuide.spacer1})`,
                        spacerLeft: `StyleGuide.Spacer(${layout.styleGuide.spacer1})`,
                        spacerRight: `StyleGuide.Spacer(${layout.styleGuide.spacer1})`,
                        spacerTop: `StyleGuide.Spacer(${layout.styleGuide.spacer1})`
                    }}
                />
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    flatlist: {
        alignItems: 'baseline',
        justifyContent: 'center',
        width: '100%',
        overflow: 'hidden',
    },
    flatlistMobile: {
        alignItems: 'center'
    },
    item: {
        position: 'relative',
        textAlign: 'center',
        alignItems: 'center',
        backgroundColor: '#fff',
    },
    copyContainer: {

    },
    buttonWrapper: {
        position: 'relative',
        justifyContent: 'flex-end',
    }
});

export default HorizontalGrid;